// extracted by css-extract-rspack-plugin
export default {"root":"rrA1r2OBOYSU0rqd","collapsedButton":"bqI6zRepmI3cYm_M"};